var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contetViewManagment"},_vm._l((_vm.getCompetitions),function(competition,index){return _c('Card',{key:index,attrs:{"competition":competition},nativeOn:{"click":function($event){return (() => _vm.editCompetition(competition._id)).apply(null, arguments)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }